var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.00135808 2.79388L2.12061 0.671875L27.5846 26.1359L25.4654 28.2579L0.00135808 2.79388Z","fill":"white","key":0}),React.createElement("path",{"d":"M25.4758 0.675555L27.5883 2.8057L2.12431 28.2697L0.0118093 26.1396L25.4758 0.675555Z","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none"};

module.exports = Close;

Close.default = Close;
